import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { getTutorCompletionStatus, type TutorCompletionMissingField } from '@/api/services/profilesApi';

export interface TutorCompletionStatus {
  isProfileComplete: boolean;
  canApply: boolean;
  completionPercentage: number;
  verificationStatus: 'not_submitted' | 'pending' | 'approved' | 'rejected';
  isFullyVerified: boolean;
  hasAboutMe: boolean;
  missingFields: TutorCompletionMissingField[];
}

/**
 * Hook to fetch tutor profile completion status and application eligibility
 * Returns { isProfileComplete, canApply, completionPercentage, verificationStatus }
 */
export const useTutorCompletionStatus = (
  userId?: string,
  enabled: boolean = true
): UseQueryResult<TutorCompletionStatus> => {
  return useQuery({
    queryKey: ['tutorCompletionStatus', userId],
    queryFn: getTutorCompletionStatus,
    enabled: enabled && !!userId,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};
